/*
 * The Organisation search module
 */
var TECL_OrgSearch = {

  /*
   * Method used to get the child orgs of the given Org Id
   */
  GetChildOrgs: function (parentOrgId) {

    var results = null;

    if (parentOrgId) {

      results = [];

      $.ajax({
        url: "/umbraco/surface/TagsAndMetadataFormSurface/GetMatOrgChildren/",
        async: false,
        data: {
          matOrgId: parentOrgId
        },
        success: function (orgResults) {

          if (orgResults && orgResults.length > 0) {

            for (var i = 0; i < orgResults.length; i++) {

              var orgResult = orgResults[i];

              // Add the org result
              results.push({
                OrgId: orgResult.Item1,
                Name: orgResult.Item2,
                Postcode: orgResult.Item3
              });
            }
          }
        }
      });
    }
    return results;
  }

};

/*
 * The org quick search module
 */
var TECL_OrgQuickSearch = {
  increment: 0,
  lastProcessedId: 0,
  acSnippet: '<ul class="ac-dropdown"></ul>',

  RemoveDropdown: function (element) {
    if ($(element).next().hasClass('ac-dropdown')) {
      $(element).next().hide(200, function () { $(element).next().remove() });
    }
  }
  ,
  CreateDropdown: function (element, data) {
    if (!$.isEmptyObject(data.results)) {
      if (parseInt(data.requestId) > parseInt(TECL_OrgQuickSearch.lastProcessedId)) {
        if (!$(element).next().hasClass('ac-dropdown')) {
          $(element).after(TECL_OrgQuickSearch.acSnippet);
        }

        $(element).next().empty();

        $.each(data.results,
          function (i, item) {
            id = item.OrgId;
            name = item.OrgName;
            postcode = item.OrgPostcode;
            $(element).next().append(
              '<li' +
              ' class="ac-option"' +
              ' data_name="' + name + '"' +
              ' data_id="' + id + '"' +
              ' data-pCode="' + postcode + '"' +
              ' >' +
              name +
              '<span class="result-postcode">' +
              postcode +
              '</span></li>'
            );
          });
        TECL_OrgQuickSearch.lastProcessedId = data.requestId;
      }
    } else {
      $(element).next().empty();
      $(element).next().append(
        '<li class="ac-no-results">No results found</li>'
      );
    }
  }
  ,
  Search: function (element, query) {
    if (query == null) {
      query = "";
    }
    if (query.length >= 2) {

      var matOnly = false;
      var matAswell = false;

      if (element) {
        var $element = $(element);
        if ($element.attr("data-matonly") === "true") {
          matOnly = true;
        } else if ($element.attr("data-mataswell") === "true") {
          matAswell = true;
        }
      }

      $.ajax({
        url: "/umbraco/surface/TagsAndMetadataFormSurface/GetOrgQuickSearchResults/",
        data: {
          searchString: query,
          requestId: TECL_OrgQuickSearch.increment,
          matSchoolsOnly: matOnly,
          includeMatSchools: matAswell
        },
        success: function (results) {
          TECL_OrgQuickSearch.CreateDropdown(element, results);
        }
      });
      TECL_OrgQuickSearch.increment++;
    }
  }
  ,
  HighlightItemBeneath: function (element) {
    currentHighlightedItem = $(element).next().children('.interested');
    if (currentHighlightedItem.length == 0) {
      $(element).next().children().first().addClass('interested');
    } else {
      currentHighlightedItem.next().addClass('interested');
      currentHighlightedItem.removeClass('interested');
    }
  }
  ,
  HighlightItemAbove: function (element) {
    currentHighlightedItem = $(element).next().children('.interested');
    if (currentHighlightedItem.length == 0) {
      $(element).next().children().first().addClass('interested');
    } else {
      currentHighlightedItem.prev().addClass('interested');
      currentHighlightedItem.removeClass('interested');
    }
  }
  ,
  SelectItem: function (element, valueId, valueName, valuePostcode) {
    var $element = $(element);
    $element.val(valueName);
    $element.attr('data_id', valueId);
    $element.attr('data_name', valueName);
    $element.attr("data-pcode", valuePostcode);

    TECL_OrgQuickSearch.TriggerCustomEvent(element);
    TECL_OrgQuickSearch.RemoveDropdown(element);
  }
  ,
  TriggerCustomEvent: function (element) {

    var $element = $(element);
    var dataId = $element.attr("data_id");
    var dataName = $element.attr("data_name");
    var postcode = $element.attr("data-pCode");
    var value = $element.val();

    if (dataName != value) {
      dataId = "";
      dataName = "";
      postcode = "";
    }

    $(element).trigger("itemSelected", [dataId, dataName, postcode]);
  }
  ,
  Initialise: function (selector, options) {

    var mouseIsIn;
    var $selectorElement = $(selector);
    var matSchoolsOnly = false;
    var includeMatSchools = false;

    if (options) {
      if (options.ReturnMatOnly !== undefined) {
        matSchoolsOnly = options.ReturnMatOnly;
      }
      if (options.ReturnMatAswell !== undefined) {
        includeMatSchools = options.ReturnMatAswell;
      }
    }

    if (matSchoolsOnly) {
      $selectorElement.attr("data-matonly", "true");
    } else if (includeMatSchools) {
      $selectorElement.attr("data-mataswell", "true");
    }

    $selectorElement.on("focus", function (e) {
      query = $(this).val();
      TECL_OrgQuickSearch.Search(this, query);
    });

    $selectorElement.on("blur", function (e) {
      if (!mouseIsIn) {
        TECL_OrgQuickSearch.RemoveDropdown(this);
      }
    });

    $selectorElement.on("input propertychange paste", function () {
      $(this).attr('data_id', '');
      $(this).attr('data_name', '');
      $(this).attr('data-pcode', '');

      query = $(this).val();
      TECL_OrgQuickSearch.Search(this, query);
      TECL_OrgQuickSearch.TriggerCustomEvent(this);
    });

    $selectorElement.on("keydown", function (e) {
      if (e.keyCode === 40) {
        TECL_OrgQuickSearch.HighlightItemBeneath(this);
      }

      if (e.keyCode === 38) {
        TECL_OrgQuickSearch.HighlightItemAbove(this);
      }

      if (e.keyCode === 13 || e.keyCode === 9) {

        var $item = $(this);

        if ($item.next().hasClass('ac-dropdown')) {

          e.preventDefault();

          if ($item.next().find('.interested').length > 0) {
            var valueName = $item.next().children('.interested').first().attr('data_name');
            var valueId = $item.next().children('.interested').first().attr('data_id');
            var valuePostcode = $item.next().children('.interested').first().attr("data-pcode");
            TECL_OrgQuickSearch.SelectItem(this, valueId, valueName, valuePostcode);
          }
        }
      }
    });

    $(document).on("mouseenter", ".ac-dropdown", function (e) {
      mouseIsIn = true;
    });

    $(document).on("mouseleave", ".ac-dropdown", function (e) {
      mouseIsIn = false;
    });

    $(document).on("click", ".ac-option", function (e) {
      var $item = $(this);
      var valueName = $item.attr('data_name');
      var valueId = $item.attr('data_id');
      var valuePostcode = $item.attr("data-pCode");
      var autocomplete = $item.parent().prev();

      TECL_OrgQuickSearch.SelectItem(autocomplete, valueId, valueName, valuePostcode);

      $(autocomplete).trigger("itemSelected", [valueId, valueName, valuePostcode]);
      TECL_OrgQuickSearch.RemoveDropdown(autocomplete);
    });

    $(document).on("click", ".ac-no-results", function (e) {
      autocomplete = $(this).parent().prev();
      TECL_OrgQuickSearch.RemoveDropdown(autocomplete);
    });
  }
};
